import {
  append,
  compose,
  concat,
  filter,
  fromPairs,
  isNil,
  keys,
  map,
  pick,
  reduce,
  toPairs,
} from "ramda"

import i18n from "../../../lib/i18n.es6"

//move this to the wrapper in the app
const states = {
  default: {
    approved: {
      color: "success",
      id: 5,
      name: "WorkflowState:Approved",
    },
    draft: {
      color: "error",
      id: 2,
      name: "WorkflowState:Draft",
    },
    live: {
      color: "success",
      id: 1,
      name: "WorkflowState:Live",
    },
    notApproved: {
      color: "secondary", //??
      id: 6,
      name: "WorkflowState:NotApproved",
    },
    readyForReview: {
      color: "info",
      id: 3,
      name: "WorkflowState:ReadyForReview",
    },
    undefined: {
      color: "secondary",
      id: 0,
      name: "WorkflowState:Undefined",
    },
    withdrawn: {
      color: "secondary", //??
      id: 7,
      name: "WorkflowState:Withdrawn",
    },
  },
  remarking: {
    final: {
      color: "success",
      id: 4,
      name: "Author.Reports.CandidateResults.Status:FinalResult",
    },
    flagged: {
      color: "error",
      id: 2,
      name: "Author.Reports.CandidateResults.Status:FlaggedForRemarking",
    },
    inProgress: {
      color: "error",
      id: 3,
      name: "Author.Reports.CandidateResults.Status:RemarkingInProgress",
    },
    intermediary: {
      color: "warning",
      id: 5,
      name: "Author.Reports.CandidateResults.Status:IntermediaryResult",
    },
    success: {
      color: "success",
      id: 1,
      name: "Author.Reports.CandidateResults.Status:FinalResult",
    },
    undefined: {
      color: "secondary",
      id: 0,
      name: "WorkflowState:Undefined",
    },
  },
  reviewSession: {
    Active: {
      color: "primary",
      id: 2,
      name: "ArchiveState:Active",
    },
    Draft: {
      color: "warning",
      id: 1,
      name: "WorkflowState:Draft",
    },
  },
  passedStatus: {
    Failed: {
      color: "error",
      id: 0,
      name: "PassedStatus:Failed",
    },
    Passed: {
      color: "success",
      id: 1,
      name: "PassedStatus:Passed",
    },
  },
}

export const getStatus = (id, type, defaultValue = "") => {
  const settings =
    type === "default"
      ? states[type][id || "undefined"]
      : Object.entries(states[type]).filter(
          ([key, value]) => `${value.id}` === `${id}` || `${key}` === `${id}`,
        )[0]

  if (Array.isArray(settings)) return settings[1]
  if (!settings) return states["default"]["undefined"]
  return settings
}

export const mapDataToRows = (array) =>
  reduce(
    (accumulator, item) => {
      const resultItem = { ...item, sectionPath: [item.id] }

      if (item.isSection) {
        return concat(
          [...accumulator, resultItem],
          map((data) => ({ ...data, sectionPath: [item.id, data.id] }), item.questions),
        )
      }

      return append(resultItem, accumulator)
    },
    [],
    array,
  )

export const getTreeDataPath = (row) => row.sectionPath

export const setColumnProperties = (columns, autoLoad) =>
  columns.map((item, index, array) => ({
    customStatus: false,
    dataIndex: item.field,
    default: false,
    disableColumnMenu: item.disableColumnMenu || !(index + 1 === array.length),
    disableReorder: autoLoad || item.disableReorder || index === 0,
    flex: item.flex || (index === 0 ? 1 : 0.3),
    hidden: false,
    index,
    isLocked: false,
    isPreview: false,
    sortable: false,
    tooltip: false,
    ...item,
  }))

export const disableColumnMenu = (columns) =>
  columns.forEach((item, index, array) => {
    item.disableColumnMenu = item.disableColumnMenu || !(index + 1 === array.length)
  })

export const mapTableInfo = (fields, rowData) =>
  compose(
    fromPairs,
    filter((item) => !isNil(item)),
    map(([key, value]) =>
      fields[key].hidden
        ? null
        : [
            i18n(fields[key].key),
            {
              asHTML: fields[key].asHTML || false,
              expandable: !!value ? fields[key].expandable : false,
              notBold: !!value ? fields[key].notBold : false,
              value: fields[key].transform ? fields[key].transform(value) : value || "-",
            },
          ],
    ),
    toPairs,
  )(pick(keys(fields), rowData))

export const setLocalStorageValues = (tableId, key, value) => {
  try {
    const storedValue = JSON.parse(localStorage.getItem(tableId)) || {}

    storedValue[key] = value

    localStorage.setItem(tableId, JSON.stringify(storedValue))
  } catch {
    // empty
  }
}

export const getLocalStorageValues = (tableId, key) => {
  try {
    if (!tableId) {
      return null
    }

    const storedValue = JSON.parse(localStorage.getItem(tableId) || null)

    if (!storedValue) {
      return null
    }

    return storedValue[key]
  } catch {
    // empty
  }
}
